import { SafeBaseObject } from "@app/core/models/base-object.models";

export class ReservationPickListPackage extends SafeBaseObject {
  packageID = 0;
  displayPackageName = '';
  packageTravelDateID = 0;
  packageTypeID = 0;
  packageTypeName = '';
  packageShortName = '';
  packageLongName = '';
  packageName = '';


  constructor(data?: any) {
    super();
    if (data) {
      super.updateData(data);
    }
  }
}

export interface IResApiGetPackageReportRM {
  PackageID?: number;
  PackageName?: string;
  RMPackageID?: number;
  RMPackageName?: string;
  PackageTypeID?: number;
  Status?: string;
  MinYear?: number;
  RMStatus?: string;
}

export class ResPackageReportRM extends SafeBaseObject {
  minYear = 0;
  packageID = 0;
  packageType = '';
  packageName = '';
  packageCode = '';
  status = '';
  RMPackageID = 0;
  RMPackageCode = '';
  RMPackageName = '';
  package2RMPackageID = 0;

  constructor(data?: any) {
    super();
    this.updateData(data);
    this.addProperty('RMPackageID', data, 'RMPackageID')
    this.addProperty('RMPackageCode', data, 'RMPackageCode')
    this.addProperty('RMPackageName', data, 'RMPackageName')
  }
}

export interface IResApiPackageMasterRM {
  RMPackageID?: number;
  RMPackageName?: string;
  RMPackageShortName?: string;
}

export class ResPackageMasterRM extends SafeBaseObject {
  RMPackageID = 0;
  RMPackageName = '';
  RMPackageShortName = '';
  pkg = 0;

  constructor(data?: any) {
    super();
    this.updateData(data);
    this.addProperty('RMPackageID', data, 'RMPackageID')
    this.addProperty('RMPackageName', data, 'RMPackageName')
    this.addProperty('RMPackageShortName', data, 'RMPackageShortName')
  }
}

export class ResPackageRMDetailRow extends SafeBaseObject {
  package2RMPackageID = 0;
  RMPackageID = 0;
  packageID = 0;
  packageName = '';
  packageShortName = '';
  packageStatus = '';
  status = 'A';

  constructor(data?: any) {
    super();
    this.updateData(data);
    this.addProperty('RMPackageID', data, 'RMPackageID')
  }
}

export interface IResApiManagePackageRM {
  RMPackageID?: number | null;
  RMPackageName?: string;
  RMPackageShortName?: string;
  Packages?: IResApiManagePackageDetailRM[];
  Status?: string;
  IsFast?: string;
}

export interface IResApiManagePackageDetailRM {
  Package2RMPackageID?: number | null;
  RMPackageID?: number | null;
  PackageID?: number;
  PackageName?: string;
  PackageShortName?: string;
  Status?: string;
}

export class ResAdmECMPkgCategory extends SafeBaseObject {
  category = '';
  
  constructor(data?: any) {
    super();
    this.updateData(data);
  }
}

export interface IResAdmManageECMMassivePackages {
  PackageIDs?: string;
	ECMCategory?: string;
	BlbGUID?: string;
}